import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import {
  FormGroup,
  TextFieldController,
  PasswordController,
  Form,
  FullPageProgress,
} from 'components';
import { pillFieldSx } from 'features/auth/containers/SignInForm/styles';
import { useWindowSize } from 'hooks';
import { passwordRules } from 'validations';
import './input.css';

import { useSignUpForm } from './hooks';
import { FIELDS_VALUE_LENGTH, firstNameRules, lastNameRules } from './rules';
import { InputW, PasswordInputW, SignUpButton, WranDescription } from './styled';

export function SignUpForm(): ReactElement {
  const { handleFormSubmit, control, isLoading, email_exist } = useSignUpForm();
  const { t } = useTranslation();
  const { isMobile } = useWindowSize();

  return (
    <>
      {isLoading && <FullPageProgress />}

      <Form onSubmit={handleFormSubmit} sx={{ marginTop: '24px' }}>
        <FormGroup row={!isMobile} marginBottom={isMobile ? 0 : 16}>
          <InputW>
            <TextFieldController
              control={control}
              name="firstName"
              id="firstName"
              label={t('signUp.form.firstName')}
              placeholder={t('signUp.form.firstName')}
              rules={firstNameRules}
              maxLength={FIELDS_VALUE_LENGTH.firstName.max}
              sx={pillFieldSx}
            />
          </InputW>
          <InputW>
            <TextFieldController
              name="lastName"
              id="lastName"
              control={control}
              label={t('signUp.form.lastName')}
              placeholder={t('signUp.form.lastName')}
              rules={lastNameRules}
              maxLength={FIELDS_VALUE_LENGTH.lastName.max}
              sx={pillFieldSx}
            />
          </InputW>
        </FormGroup>
        <FormGroup marginBottom={isMobile ? 24 : 16}>
          <TextFieldController
            name="email"
            id="email"
            control={control}
            type="email"
            label={t('signUp.form.email')}
            placeholder={t('signUp.form.email')}
            autoComplete="new-password"
            maxLength={FIELDS_VALUE_LENGTH.email.max}
            sx={{ ...pillFieldSx, width: '100%' }}
            disabled
          />
        </FormGroup>
        <FormGroup
          marginBottom={isMobile ? 24 : 16}
          row
          sx={{ alignItems: 'flex-end', flexFlow: 'row' }}
        >
          {!email_exist && (
            <PasswordInputW>
              <PasswordController
                name="password"
                id="password"
                control={control}
                label={t('signUp.form.password')}
                placeholder={t('signUp.form.password')}
                autoComplete="new-password"
                rules={passwordRules}
                maxLength={FIELDS_VALUE_LENGTH.password.max}
                sx={pillFieldSx}
                withAdornment
              />
            </PasswordInputW>
          )}
          {email_exist && (
            <WranDescription>{t('companyRegistration.warnMessage.title')}</WranDescription>
          )}
        </FormGroup>

        <FormGroup marginBottom={0} row sx={{ alignItems: 'flex-end', flexFlow: 'row' }}>
          <SignUpButton type="submit" variant="contained" color="info">
            {t('signUp.signUpBtn')}
          </SignUpButton>
        </FormGroup>
      </Form>
    </>
  );
}
